import { defineMessages } from 'react-intl'

export default defineMessages({
  successTitle: {
    id: 'editExpenseLineItemPresenter.successTitle',
    defaultMessage: 'Success',
  },
  successMessage: {
    id: 'editExpenseLineItemPresenter.successMessage',
    defaultMessage: 'Item has been saved',
  },
  errorTitle: {
    id: 'editExpenseLineItemPresenter.errorTitle',
    defaultMessage: 'Error',
  },
  errorMessage: {
    id: 'editExpenseLineItemPresenter.errorMessage',
    defaultMessage: 'Failed to save item',
  },
})
